import React, { useMemo, useState, useRef, useEffect, useContext } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";

export const useWelcomeKitList = () => {
  const { showError } = useContext(ToastContext);
  const [rowData, setRowData] = useState([]);
  const [loader, setLoader] = useState(false);
  const tagRef = useRef();
  const [filterValues, setFilterValues] = useState({ Status: { label: "Pending", value: "pending" } });
  const [filterOpts] = useState({ Status: [{ label: "Pending", value: "pending" }, { label: "Submitted", value: "submitted" }, { label: "Partial Done", value: "done" }, { label: "Expired", value: "expired" }] });
  const [search, setSearch] = useState("");
  const [allRowData, setAllRowData] = useState([]);
  const columns = [
    {
      key: 'employee_id',
      label: 'Employee ID',
      style: {
        width: (filterValues.Status.value === "pending" || filterValues.Status.value === "done") ? "50%" : "20%"
      },
      render: (row) => <div> {row.employee_id}</div>
    },
    {
      key: 'user_display_name',
      label: 'Employee Name',
      style: { width: (filterValues.Status.value === "pending" || filterValues.Status.value === "done") ? "50%" : "15%" },
      render: (row) => <div >{row.user_display_name}</div>
    },
    {
      key: 'submit_datetime',
      label: 'Submited Date',
      style: { textAlign: "center", width: "20%" },
      headerStyle: { textAlign: "center" },
      hide: filterValues.Status.value === "pending" || filterValues.Status.value === "done",
      render: (row) => <div>{row?.submit_datetime ? dateConvert(row?.submit_datetime, "date-time-months") : "-"}</div>
    },
    {
      key: 'modify_by',
      label: 'Modify By',
      style: { textAlign: "center", width: "20%" },
      headerStyle: { textAlign: "center" },
      hide: filterValues.Status.value === "pending" || filterValues.Status.value === "done",
      render: (row) => <div>{row?.modify_by ? dateConvert(row?.modify_by, "date-time-months") : "-"}</div>
    },
    {
      key: 'modify_datetime',
      label: 'Last Modify Date',
      style: { textAlign: "center", width: "20%" },
      headerStyle: { textAlign: "center" },
      hide: filterValues.Status.value === "pending" || filterValues.Status.value === "done",

      render: (row) => <div>{row?.modify_datetime ? dateConvert(row?.modify_datetime, "date-time-months") : "-"}</div>
    },
    {
      key: 'welcomekit_pdf_url',
      label: 'Download',
      style: { textAlign: "center", width: "5%" },
      headerStyle: { textAlign: "center" },
      hide: filterValues.Status.value === "pending" || filterValues.Status.value === "done",
      render: (row) => <div className="c-pointer" onClick={() => handleDownload(row)}>
        <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
      </div>
    },
  ];

  const handleDownload = (data) => {
    try {
      fetch(data?.welcomekit_pdf_url, { method: "GET", mode: "cors" })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `welcome_kit${data?.user_display_name}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          showError("Error", "Failed to download PDF.");
        });
    } catch (error) {
      console.error(error);
      showError("Error", "Unexpected error occurred while downloading PDF.");
    }
  };


  const getWelcomeKitData = async () => {
    try {
      setLoader(true);
      const payload = {
        is_pending: filterValues.Status.value === "pending",
        is_expired: filterValues.Status.value === "expired",
        is_partial: filterValues.Status.value === "done",
      }
      const res = await services.getInvokeRemote("POST", Urls("GETEMPLOYEEWELCOMEKITSTATUS"), payload);
      if (res?.body?.data?.user_welocomekit_status) {
        const data = [{
          id: 'all',
          title: "",
          children: res?.body?.data?.user_welocomekit_status
        }];
        setAllRowData(data);
        setRowData(data)
      } else {
        setAllRowData([])
        setRowData([]);
      }
    } catch (error) {
      console.error("WelcomeKit API Error:", error);
      setAllRowData([]);
      setRowData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getWelcomeKitData();
  }, [filterValues.Status.value]);

  const onFilterTextBoxChanged = (value) => {
    const val = value?.toLowerCase().trim();
    setSearch(val);
    const allRows = allRowData[0]?.children || [];
    if (!val) {
      setRowData(allRowData);
      return;
    }
    const isPhraseSearch = val?.includes(" ");
    const filtered = allRows.filter((row) => {
      const text = Object.values(row).join(" ").toLowerCase();
      if (isPhraseSearch) {
        return text.includes(val);
      } else {
        return text.split(/\s+/).some((word) => word.includes(val));
      }
    });
    setRowData([{ id: 'all', title: '', children: filtered }]);
  };



  return useMemo(() => ({
    columns, rowData, tagRef, loader, filterValues, setFilterValues, filterOpts, getWelcomeKitData, search, setSearch, onFilterTextBoxChanged
  }), [columns, rowData, tagRef, loader, filterValues, setFilterValues, filterOpts, getWelcomeKitData, search, setSearch, onFilterTextBoxChanged]);
};